import type { Feature } from '@/shared/registry'

/** "/", which sends each person on to their own landing page. */
export const feature: Feature = {
  id: 'home',
  routes: [
    {
      path: '/',
      titleId: 'home.title',
      page: () => import('./HomePage').then((module) => module.HomePage),
    },
  ],
}
